import { Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

export function DrawerContentHeader(
  props: Readonly<PropsWithChildren<{ id?: string }>>,
) {
  return (
    <Typography
      id={props.id}
      component='h3'
      variant='h6'
      color='text.secondary'
    >
      {props.children}
    </Typography>
  );
}
